import { isMobile } from 'mobile-device-detect'

export default function() {
    return {
        isMobile,
        availableAccommodations: [],
        availablePeopleTypes: [],
        trip: {
            cover: '',
            boardingPlaces: [],
            accommodations: [],
            optionals: [],
            images: [],
            videoId: null,
            videoUrl: null,
            place: {
                name: null,
                id: null
            }
        },
        lastBoardingDate: null,
        success: false,
        error: false,
        errorMessage: '',
        videoError: null,
        apiUrl: process.env.VUE_APP_API_URL,
        baseUrl: process.env.VUE_APP_BASE_URL,
        customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
        datePickerConfig: {
            nextMonthCaption: 'Próximo mês',
            prevMonthCaption: 'Mês anterior',
            setTimeCaption: 'Hora',
            weekdays: [
                'S', 'T', 'Q', 'Q', 'S', 'S', 'D'
            ],
            months: [
                'Janeiro', 'Fevereiro', 'Março', 'Abril',
                'Maio', 'Junho', 'Julho', 'Agosto',
                'Setembro', 'Outubro', 'Novembro', 'Dezembro'
            ]
        },
        errors: {
            eventTitle: null,
            place: null,
            startTime: null,
            stopTime: null,
            cover: null,
            description: null,
            itinerary: null,
            accommodations: [],
            boardingPlaces: [],
            optionals: [],
            returnPlace: null,
            isIncluded: null,
            isNotIncluded: null,
            term: null,
            summary: null,
            kid_conditions: null,
            pet_conditions: null
        },
        validationErrorMessages: {
            boardingPlaces: {
                mandatory: 'Você precisa preencher pelo menos um item na seção "Locais de embarque"',
                intervalBetweenDates: 'Os embarques devem ter uma distância máxima de 8 horas entre eles.',
                dateLess: 'Não pode inserir uma data menor que a anterior.'
            },
            accommodations: {
                mandatory: 'Você precisa preencher pelo menos um item na seção "Valores e Vagas"',
                mandatoryAdult: 'Precisa fornecer o valor de pelo menos um Adulto'
            }
        },
        drop: true,
        gallery: [],
        multiple: true,
        accept: 'image/png,image/jpeg,image/jpg',
        extensions: 'jpg,jpeg,png',
        blockRemoval: false,
        croppingImage: null,
        showCropper: false,
        croppingModel: null,
        currentGalleryImageCrop: null,
        showLongBoardingIntervalsModal: false,
        showLongReturnIntervalModal: false,

    }
}
